import CardComparison from '~/components/sanity/modules/CardComparison.vue';
import Plans from '~/components/sanity/modules/Plans.vue';
import Hero from '~/components/sanity/modules/Hero.vue';
import JumboHero from '~/components/sanity/modules/JumboHero.vue';
import Feature1 from '~/components/sanity/modules/Feature1.vue';
import Feature2 from '~/components/sanity/modules/Feature2.vue';
import CtaSection from '~/components/sanity/modules/CTASection.vue';
import Grid from '~/components/sanity/modules/Grid.vue';
import TabSection from '~/components/sanity/modules/TabSection.vue';
import HowItWorks from '~/components/sanity/modules/HowItWorks.vue';
import Testimonials from '~/components/sanity/modules/Testimonials.vue';
import Widget from '~/components/sanity/modules/SanityWidget.vue';
export default {
  name: 'Modules',
  components: {
    CardComparison,
    Hero,
    JumboHero,
    Feature1,
    Grid,
    Plans,
    Feature2,
    CtaSection,
    TabSection,
    HowItWorks,
    Testimonials,
    Widget
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      widgetScript: []
    };
  },
  fetch() {
    if (this.data._type === 'widget') {
      this.widgetScript.push(this.data.externalJs ? {
        src: this.data.externalJs
      } : '', this.data.uploadedFile ? {
        src: this.data.uploadedFile,
        body: true
      } : '');
    }
  },
  head() {
    return {
      script: this.widgetScript
    };
  },
  computed: {
    dataType() {
      if (this.data._type === 'staticFeatures') return this.data.feature;else return this.data._type;
    }
  }
};